<template>
  <a-tooltip :style="{ width } " overlayClassName="custom-tooltip" :placement="placement">
    <template #title>
      <slot ></slot>
    </template>
    <InformationOutlineIcon class="fill-primary icon-size-lg"></InformationOutlineIcon>
  </a-tooltip>
</template>

<script>
export default {
  name: "InformationTooltip.vue",
  props: {
    placement: {
      type: String,
      default: "right",
    },
    width: {
      type: String,
      default: "400px",
    },
  }
};
</script>

<style lang="scss">
@import "~@/_default.scss";

.ant-tooltip.custom-tooltip {
  .ant-tooltip-inner {
    background-color: white;
    box-shadow: $shadow-xxl;
    padding: $spacing-md;
    border-radius: $border-radius-base;
    color: $text-color;
    font-size: $font-size-small;
    position: relative;
    overflow: clip;
    width: 350px;
    &:before {
      position: absolute;
      content: '';
      background-color: $brand-primary;
    }
  }
  &.ant-tooltip-placement-left {
    .ant-tooltip-inner:before {
      right: 0;
      height: 100%;
      top: 0;
      bottom: 0;
      width: 4px;
    }
  }
  &.ant-tooltip-placement-right {
    .ant-tooltip-inner:before {
      left: 0;
      height: 100%;
      top: 0;
      bottom: 0;
      width: 4px;
    }
  }
  &.ant-tooltip-placement-top {
    .ant-tooltip-inner:before {
      left: 0;
      width: 100%;
      right: 0;
      bottom: 0;
      height: 4px;
    }
  }
  &.ant-tooltip-placement-bottom {
    .ant-tooltip-inner:before {
      left: 0;
      width: 100%;
      right: 0;
      top: 0;
      height: 4px;
    }
  }
  .ant-tooltip-arrow::before {
    background-color: $brand-primary;
  }
}
</style>
